import { render, staticRenderFns } from "./MedicationsOnAtStartPanel.vue?vue&type=template&id=6dafd108&scoped=true&"
import script from "./MedicationsOnAtStartPanel.vue?vue&type=script&lang=js&"
export * from "./MedicationsOnAtStartPanel.vue?vue&type=script&lang=js&"
import style0 from "./MedicationsOnAtStartPanel.vue?vue&type=style&index=0&id=6dafd108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dafd108",
  null
  
)

export default component.exports